import { SDKInitParams } from "~/server/types/auth";
import { SetStoreFunction } from "solid-js/store";
import { createContext, JSX, ResourceReturn, useContext } from "solid-js";
import { HomepageMetaData } from "~/server/types/brand";

import { ClassicContextStore, useClassicView } from "./useClassicView";

export type ClassicAppContext = {
  data: ClassicContextStore;
  setClassicContextData: SetStoreFunction<ClassicContextStore>;
  isClientDonationType: () => boolean;
  homepageMetaDataResource: ResourceReturn<HomepageMetaData, unknown>;
  login: (onAfterLogin: () => void) => void;
  logout: () => void;
};

export type ClassicViewInitParams =
  | {
      mode: "hubble";
    }
  | {
      mode: "sdk";
      sdkInitParams: SDKInitParams;
    };

const ClassicAppContext = createContext<ClassicAppContext>();

export type ClassicContextProviderProps = {
  children: JSX.Element;
  classicContextStore: ClassicContextStore;
};
export function ClassicContextProvider(props: ClassicContextProviderProps) {
  const classicViewData = useClassicView(props.classicContextStore);
  return (
    <ClassicAppContext.Provider value={classicViewData}>
      {props.children}
    </ClassicAppContext.Provider>
  );
}

export function useClassicContext() {
  return useContext(ClassicAppContext)!;
}
